import React, { useEffect } from "react";

import "../style/About.css";
import "../style/Session.css";

import { useDispatch, useSelector } from "react-redux";
import { SPICE_CARDS } from "../utils/aboutUtils";
import { GRAPHICS, IMAGES, hasData } from "../utils/utils";
import { fetchHistoryArticles } from "../api/history/history.reduxThunk";
import { motion } from "framer-motion";
import { fetchAboutBG, fetchAboutNumber } from "../api/reduxThunk";
import usePageSetup from "../hooks/usePageSetup";
import SlideWrapper from "../components/generics/SlideWrapper";
import { slideUp } from "../utils/animationUtils";
import OriginText from "../components/about/OriginText";
import XoiComHeading from "../components/generics/XoiComHeading";
import ProcessSession from "../components/about/ProcessSession";
import GreenSession from "../components/about/GreenSession";
import LazyImage from "../components/generics/LazyImage";
import LoadingBackdrop from "../components/skeleton/LoadingBackdrop";

const { MEMORY_IMG } = IMAGES;

function SlideUp({ children, className }) {
  return (
    <motion.div
      className={className}
      variants={slideUp}
      initial="initial"
      whileInView="animate"
      viewport={{ once: true }}
    >
      {children}
    </motion.div>
  );
}

function About() {
  const dispatch = useDispatch();

  usePageSetup("light");

  const aboutBackground = useSelector((state) => state.reducer.aboutBackground);
  const aboutText = useSelector((state) => state.reducer.aboutText);
  const language = useSelector((state) => state.reducer.language);
  const { landingText, memory, origin, process, green } = aboutText;

  const loading = useSelector((state) => state.reducer.loading);
  const historyCards = useSelector((state) => state.reducer.history);
  const hasHistory = hasData(historyCards);

  useEffect(() => {
    dispatch(fetchAboutBG());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(fetchHistoryArticles());
    dispatch(fetchAboutNumber());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);

  return (
    <div>
      <LoadingBackdrop open={loading} />
      <div className="landing-session">
        <LazyImage
          className="landing-image"
          alt="about-landing"
          imageSrc={aboutBackground}
        />
        <SlideUp className="landing-text">
          <XoiComHeading heading={landingText} textColor="white" bigHeader />
        </SlideUp>
      </div>
      <div className="about-spice-session">
        <SlideUp className="spice-slide-container">
          <SlideWrapper steps={SPICE_CARDS} mode="spice" />
        </SlideUp>
        <SlideUp className="about-memory">
          <div className="memory-text">
            <div className="cap-r15">{memory.heading}</div>
            <h2>{memory.bodyText}</h2>
          </div>
          <img className="memory-img" src={MEMORY_IMG} alt="memory" />{" "}
        </SlideUp>
      </div>
      <div style={{ position: "relative" }}>
        <div className="about-origin-session">
          <OriginText content={origin} />
          <img
            className="about-origin-logo"
            src={GRAPHICS.HEADER_LOGO_WHITE}
            alt="xoi-com-logo"
          />
        </div>
      </div>
      {hasHistory && (
        <div className="about-journey-session">
          <SlideWrapper steps={historyCards} mode="history" />
        </div>
      )}
      <ProcessSession heading={process} />
      <GreenSession heading={green} />
    </div>
  );
}

export default About;
